import { kGroundSurfaceTempAmplitudesData } from './GroundSurfaceTempAmplitudesData.js'
import { CsvHelper } from '../MaterialData/CsvHelper.js'

function findNearestValue(csv, startRow, startCol) {
  // Proper BFS to find nearest non-zero value
  const queue = [[startRow, startCol]];
  const visited = new Set();
  visited.add(`${startRow},${startCol}`);
  
  while (queue.length > 0) {
    const [row, col] = queue.shift();
    
    // Check all 8 adjacent cells
    const directions = [
      [-1, -1], [-1, 0], [-1, 1],
      [0, -1],           [0, 1],
      [1, -1],  [1, 0],  [1, 1]
    ];
    
    for (const [dr, dc] of directions) {
      const newRow = row + dr;
      const newCol = col + dc;
      const key = `${newRow},${newCol}`;
      
      // Check bounds and if already visited
      if (newRow >= 1 && newRow < csv.numRows() && 
          newCol >= 1 && newCol < csv.numCols() && 
          !visited.has(key)) {
        
        visited.add(key);
        const val = csv.lookupValue(newRow, newCol, Number);
        
        if (val !== 0) {
          console.log(`Found nearest non-zero value: ${val} at (${newRow}, ${newCol})`);
          return val;
        }
        
        queue.push([newRow, newCol]);
      }
    }
  }
  
  console.log(`Could not find any non-zero value`);
  return 0;
}

export class GroundSurfaceTempAmplitudes {
  static lookupValue(latitude, longitude) {
    //console.log(`Looking up ground surf. temp amplitude for Lat=${latitude}, Long=${longitude}`)
    let csv = new CsvHelper(kGroundSurfaceTempAmplitudesData);

    // Find row (latitude)
    let targetRow = null;
    for (let i = 1; i + 1 < csv.numRows(); ++i) {
      // Numbers are from 90->0
      let valA = csv.lookupValue(i, 0, Number);
      let valB = csv.lookupValue(i + 1, 0, Number);
      // console.log(`Checking lat b/w ${valA} and ${valB}`)
      if (valA >= latitude && latitude >= valB) {
        // console.log("FOUND");
        targetRow = i + 1;
        break;
      }
    }
    if (targetRow === null) {
      //console.log("Could not find proper row");
      return 0;
    }

    // Find col (longitude)
    let targetCol = null;
    for (let i = 1; i + 1 < csv.numCols(); ++i) {
      // Numbers are from 180->0. Convert to -180->0 (aka 180W to 0)
      let valA = -1 * csv.lookupValue(0, i, Number);
      let valB = -1 * csv.lookupValue(0, i + 1, Number);
      // console.log(`Checking long b/w ${valA} and ${valB}`)
      if (valB >= longitude && longitude >= valA) {
        // console.log("FOUND");
        targetCol = i + 1;
        break;
      }
    }
    if (targetCol === null) {
      //console.log(`Could not find a proper col`);
      return 0;
    }

    let res = csv.lookupValue(targetRow, targetCol, Number);
    //console.log(`Found temp: ${res} (${targetRow}, ${targetCol})`);
    
    // If we get a 0 value, means we are in water. See if there is an adjacent non-zero value
    // that we can use instead.
    if (res == 0) {
      console.log(`Value is 0, looking for nearest non-zero value, at (${targetRow}, ${targetCol})`);
      res = findNearestValue(csv, targetRow, targetCol);
    }
    return res;
  }
};

